var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"formContainer",staticClass:"wrapp"},[_c('div',{staticClass:"bg"}),_c('statistic',{attrs:{"slug":_vm.slug}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }